exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3kzX6lO9Wa2rdRJY6NQRVv{padding:60px 30px;text-align:center}._3FcvrhAUC2dwNo6-YcmgMU{max-width:920px;margin:40px auto 120px auto}@media screen and (min-width: 1024px){._3FcvrhAUC2dwNo6-YcmgMU{display:flex}._3FcvrhAUC2dwNo6-YcmgMU>*{min-width:0;flex:1 1 0px;margin-right:30px}}._3FcvrhAUC2dwNo6-YcmgMU>*:last-child{margin-right:0px}._2a9QYpAAaiSX5XChjKtcoW{max-width:641px;margin:0 auto}._1ygQvIzGCEBi4NWwyjCmjH{color:#5c5c5c}\n", ""]);

// Exports
exports.locals = {
	"EmptyDashboard": "_3kzX6lO9Wa2rdRJY6NQRVv",
	"cards": "_3FcvrhAUC2dwNo6-YcmgMU",
	"constrainWidth": "_2a9QYpAAaiSX5XChjKtcoW",
	"help": "_1ygQvIzGCEBi4NWwyjCmjH"
};